<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <div id="popup-root"></div>
</template>
<script setup lang="ts">
</script>